export default __webpack_public_path__ + "static/media/endocr.70edc41d.svg";